// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DatabaseSettings  {
    _originalTypeClassName = "LoomTenantManagement.BO.DatabaseSettings";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DatabaseSettings.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Server = null;
this.Port = null;
this.User = null;
this.Password = null;
this.EncryptionKey = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Server:any;
Port:any;
User:any;
Password:any;
EncryptionKey:any;

static GenerateRandomPassword(length: any): any{if ((CLMS.Framework.Number.LessThan(() => length, () => 4))) {throw Error("Password length must be at least 4 characters long.");}
let lowerCaseStr = "abcdefghijklmnopqrstuvwxyz";
let upperCaseStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
let digitsStr = "1234567890";
let symbolsStr = "!@#$%^&*()-_=+<>";
let password = [];
password?.add(lowerCaseStr[System.Random.integer(0, lowerCaseStr?.length)]);
password?.add(upperCaseStr[System.Random.integer(0, upperCaseStr?.length)]);
password?.add(digitsStr[System.Random.integer(0, digitsStr?.length)]);
password?.add(symbolsStr[System.Random.integer(0, symbolsStr?.length)]);
let allChars = lowerCaseStr + upperCaseStr + digitsStr + symbolsStr;
for (var i = 4; CLMS.Framework.Number.LessThan(() => i, () => length); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
password?.add(allChars[System.Random.integer(0, allChars?.length)]);}

for (var i = Joove.Common.safeNumber(password?.length) - Joove.Common.safeNumber(1); CLMS.Framework.Number.GreaterThan(() => i, () => 0); i = Joove.Common.safeNumber(i) - Joove.Common.safeNumber(1)) {
let j = System.Random.integer(0, Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1));let temp = password[i];password[i] = password[j];password[j] = temp;}

return CLMS.Framework.String.Join("", password);
}
static GetConnectionString($this: any): any{return CLMS.Framework.String.Format("Server={0};Port={1};User ID={2};Password={3};Database={4}", $this?.Server, $this?.Port, $this?.User, $this?.Password, $this?.Name);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}